function f(o){let r=new Set,s=!1,a=o,e,c=(t={})=>{e={...e,...t},i();},i=()=>{if(s)return;let t=!1;if(e){for(let n in e)if(a[n]!==e[n]){t=!0;break}}t&&(a={...a,...e},r.forEach(n=>n({state:a,updatedProperties:e})),e=void 0);};return {subscribe:t=>(r.add(t),()=>{r.delete(t);}),cleanup:()=>r.clear(),getState:()=>a,setState:c,batch:t=>{s=!0,t(),s=!1,i();}}}

export { f as a };
